import React, { useEffect, useState } from "react";
import RGL, { WidthProvider, Layout } from "react-grid-layout";
import TotalOfferperStatus from "./Wedgits/total-offer-status";
import TrenderQuatationsList from "./Wedgits/treder-quatations-list";
import { useSelector } from "react-redux";
import { RootState } from "@/store/type";
import { StaticDashboard } from "./Wedgits/StaticDashboard";
import { FaUsers } from "react-icons/fa";
import { LuFileBox } from "react-icons/lu";
import { GoPackageDependencies } from "react-icons/go";
import { TbFileInvoice } from "react-icons/tb";
import OrdersBList from "./Wedgits/OrdersBList";
import { isUndefined } from "lodash";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import { ROLE } from "@/types";

// import useRegisterCompany from "@/hooks/use-register-company";
import CompleteProfile from "./Wedgits/CompleteProfile";
import useProfile from "@/hooks/use-profile";
import { useDispatch } from "react-redux";
import { getMyCompany } from "@/store/authSlice";

const ReactGridLayout = WidthProvider(RGL);

interface ExtraLargeGridProps {}

const ExtraLargeGrid: React.FC<ExtraLargeGridProps> = () => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const layout: Layout[] = [
    { i: "1", x: 0, y: 0, w: 6, h: 5, static: true },
    { i: "2", x: 6, y: 0, w: 6, h: 5, static: true },
    { i: "3", x: 0, y: 5, w: 6, h: 5, static: true },
    { i: "4", x: 6, y: 5, w: 6, h: 5, static: true },
    { i: "5", x: 0, y: 10, w: 12, h: 18, static: true },
    { i: "6", x: 0, y: 28, w: 12, h: 15, static: true },
    { i: "7", x: 0, y: 43, w: 12, h: 15, static: true },
  ];

  const [completProfile, setCompletProfile] = useState({
    profile: true,
    company: true,
  });
  // const { getCompanyMine } = useRegisterCompany();

  const authUser = useSelector((state: RootState) => state.auth.authUser);
  const userRole = isUndefined(authUser?.role) ? "" : authUser?.role;
  const { getUserProfile } = useProfile();
  const dispatch = useDispatch();

  useEffect(() => {
    getUserProfile()
      .then((res) => {
        dispatch(getMyCompany(res.data.company));
        setCompletProfile({
          company: Boolean(res.data.company),
          profile: Boolean(res.data.user.phoneNumber),
        });
      })
      .catch((_) => {
        setCompletProfile({
          profile: true,
          company: true,
        });
      });
  }, []);
  const level = () => {
    if (!completProfile.company && !completProfile.profile) {
      return "0%";
    } else if (completProfile.company && completProfile.profile) {
      return false;
    } else {
      return "50%";
    }
  };
  return (
    <div
      className="module-list-scroll scrollbar actionSidebar"
      style={{ direction: "ltr" }}
    >
      {level() ? (
        <CompleteProfile
          isCompany={!!completProfile?.company}
          isProfile={!!completProfile?.profile}
          level={level()}
        />
      ) : (
        ""
      )}

      <ReactGridLayout
        className="layout"
        layout={layout}
        rowHeight={20}
        isDraggable={false}
        isResizable={false}
      >
        <div style={{ backgroundColor: "white", zIndex: 3 }} key="1">
          <span className="text">
            <StaticDashboard
              day={t("general.comparedTo30Days")}
              percentage={"٤%"}
              logo={<FaUsers />}
              title={t("general.suppliers")}
              subTitle={0}
            />
          </span>
        </div>
        <div style={{ backgroundColor: "white", zIndex: 3 }} key="2">
          <span className="text">
            <StaticDashboard
              day={t("general.comparedTo30Days")}
              percentage={"٤%"}
              logo={<LuFileBox />}
              title={t("general.openOpportunities")}
              subTitle={0}
            />
          </span>
        </div>
        <div style={{ backgroundColor: "white", zIndex: 3 }} key="3">
          <span className="text">
            <StaticDashboard
              day={t("general.comparedTo30Days")}
              percentage={"٤%"}
              logo={<GoPackageDependencies />}
              title={
                userRole === ROLE.SELLER
                  ? t("general.sales")
                  : t("general.Purchases")
              }
              subTitle={0}
            />
          </span>
        </div>
        <div style={{ backgroundColor: "white", zIndex: 3 }} key="4">
          <span className="text">
            {" "}
            <StaticDashboard
              day={t("general.comparedTo30Days")}
              percentage={"٤%"}
              logo={<TbFileInvoice />}
              title={t("general.displayedOpportunities")}
              subTitle={0}
            />
          </span>
        </div>
        <div style={{ backgroundColor: "white", zIndex: 3 }} key="5">
          <span className="text">
            <TotalOfferperStatus />
          </span>
        </div>
        <div style={{ backgroundColor: "white", zIndex: 3 }} key="6">
          <span className="text">
            <TrenderQuatationsList />
          </span>
        </div>
        <div style={{ backgroundColor: "white", zIndex: 3 }} key="7">
          <span className="text">
            <OrdersBList />
          </span>
        </div>

        {/*     <div style={{ backgroundColor: 'white', zIndex: 3 }} key="8">
          <span className="text"><ListOfClosedOffers/></span>
        </div>*/}
      </ReactGridLayout>
    </div>
  );
};

export default ExtraLargeGrid;
